export default __webpack_public_path__ + "static/media/hero.659bc9a7.jpg";